import React from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  useMediaQuery
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const BrandingSettingsPageSkeleton = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <SkeletonTheme baseColor="#f0f0f0" highlightColor="#e0e0e0">
      <Box>
        <Box sx={{ mb: { xs: 3, md: 5 } }}>
          <Box sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', sm: 'center' },
            gap: 2,
            mb: 1
          }}>
            <Skeleton height={isMobile ? 36 : 48} width={isMobile ? 260 : 350} />
            <Skeleton height={40} width={120} style={{ borderRadius: '12px' }} />
          </Box>
          <Skeleton height={isMobile ? 20 : 28} width={isMobile ? '100%' : 500} />
        </Box>

        <Grid container spacing={{ xs: 2, md: 3 }}>
          <Grid item xs={12}>
            <Card sx={{
              borderRadius: '20px',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
            }}>
              <CardContent sx={{ p: { xs: 2, md: 4 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                  <Skeleton circle width={isMobile ? 40 : 48} height={isMobile ? 40 : 48} />
                  <Skeleton height={isMobile ? 24 : 32} width={isMobile ? 180 : 250} />
                </Box>
                <Grid container spacing={{ xs: 2, md: 3 }}>
                  <Grid item xs={12}>
                    <Skeleton height={isMobile ? 150 : 200} style={{ borderRadius: '12px', marginBottom: '16px' }} />
                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                      <Skeleton height={40} width={120} style={{ borderRadius: '8px' }} />
                      <Skeleton height={40} width={120} style={{ borderRadius: '8px' }} />
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Skeleton height={isMobile ? 100 : 140} style={{ borderRadius: '12px' }} />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Skeleton height={56} style={{ borderRadius: '12px' }} />
                    <Skeleton height={16} width={isMobile ? '100%' : 200} style={{ marginTop: '4px' }} />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Skeleton height={isMobile ? 80 : 120} style={{ borderRadius: '12px' }} />
                    <Skeleton height={16} width={isMobile ? '100%' : 220} style={{ marginTop: '4px' }} />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12}>
            <Card sx={{
              borderRadius: '20px',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
            }}>
              <CardContent sx={{ p: { xs: 2, md: 4 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                  <Skeleton circle width={isMobile ? 40 : 48} height={isMobile ? 40 : 48} />
                  <Skeleton height={isMobile ? 24 : 32} width={isMobile ? 160 : 220} />
                </Box>
                <Box sx={{ maxWidth: { xs: '100%', md: 600 } }}>
                  <Skeleton height={24} width={isMobile ? 150 : 200} style={{ marginBottom: '16px' }} />
                  <Box sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: 2,
                    alignItems: 'stretch',
                    mb: 2
                  }}>
                    <Box sx={{ flex: 1 }}>
                      <Skeleton height={56} style={{ borderRadius: '12px' }} />
                    </Box>
                    <Skeleton width={isMobile ? '100%' : 120} height={56} style={{ borderRadius: '12px' }} />
                  </Box>
                  <Skeleton height={16} width={isMobile ? '100%' : 350} style={{ marginBottom: '16px' }} />
                  <Skeleton height={80} style={{ borderRadius: '12px', marginBottom: '16px' }} />
                  <Skeleton height={100} style={{ borderRadius: '12px' }} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Box mt={{ xs: 3, md: 5 }} display="flex" justifyContent="center">
          <Skeleton height={56} width={200} style={{ borderRadius: '12px' }} />
        </Box>
      </Box>
    </SkeletonTheme>
  );
};

export default BrandingSettingsPageSkeleton;
